module.exports = __webpack_public_path__ + "static/media/robot.38ff34cf.jpeg";